module.exports = __webpack_public_path__ + "static/media/upi-icici.b3e2f158.png";